<template>
  <div class="main">
    <b-table
      :items="histories"
      :fields="fields"
      class="table-bordered table-hover col-md-12"
      :busy="isLoading"
      show-empty
      :empty-text="
        loadError
          ? 'Không tải được lịch sử thay đổi, vui lòng thử lại'
          : 'Chưa có thay đổi họ tên, SĐT, CCCD, ngày sinh'
      "
    >
      <template v-slot:table-busy>
        <vcl-table :speed="5" :animate="true" :columns="4"></vcl-table>
      </template>
      <template v-slot:cell(changedAt)="row">
        <p class="mb-0 font-weight-bold">{{ row.item.changedAt }}</p>
        <p class="mb-0">{{ row.item.changedBy }}</p>
      </template>
      <template v-slot:cell(changes)="row">
        <div
          v-for="change in row.item.changes"
          :key="change.field"
          class="change-item"
        >
          <span class="text-capitalize font-weight-bold"
            >{{ change.fieldName }}:</span
          >
          <span class="old-value">{{ change.oldValue || '(trống)' }}</span>
          <i class="fas fa-long-arrow-alt-right mx-2"></i>
          <span class="text-success">{{ change.newValue || '(trống)' }}</span>
        </div>
      </template>
      <template v-slot:cell(channel)="row">
        <p class="mb-0">{{ row.item.channel }}</p>
        <p v-if="row.item.reason" class="mb-0 text-muted">
          Lý do: {{ row.item.reason }}
        </p>
      </template>
    </b-table>
    <b-row>
      <b-col md="3">
        <p class="mt-3 text-dark font-weight-bold">Tổng số: {{ totalItems }}</p>
      </b-col>
      <b-col md="9">
        <b-pagination
          v-show="totalPages >= 2"
          v-model="currentPage"
          :total-rows="totalItems"
          :per-page="limit"
          align="right"
          size="sm"
          class="mt-2"
          @change="fetchHistories"
        ></b-pagination>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import ApiService from '@/core/services/api.service';
import { VclTable } from 'vue-content-loading';
import { makeToastFaile } from '@/utils/common';

// t102865: lịch sử thay đổi họ tên, SĐT, CCCD, ngày sinh của khách hàng
export default {
  props: ['customerId'],
  components: {
    VclTable,
  },
  data() {
    return {
      histories: [],
      isLoading: false,
      loadError: false,
      currentPage: 1,
      limit: 10,
      totalItems: 0,
      totalPages: 0,
      fields: [
        {
          key: 'changedAt',
          label: 'Thời gian / Người sửa',
          thStyle: { width: '18%' },
        },
        { key: 'changes', label: 'Nội dung thay đổi' },
        { key: 'channel', label: 'Kênh', thStyle: { width: '25%' } },
      ],
    };
  },
  watch: {
    customerId() {
      this.fetchHistories(1);
    },
  },
  mounted() {
    this.fetchHistories(1);
  },
  methods: {
    fetchHistories(page = this.currentPage) {
      if (!this.customerId) return;
      this.isLoading = true;
      this.loadError = false;
      const params = { page, limit: this.limit };
      ApiService.query(`customer/${this.customerId}/profile-histories`, {
        params,
      })
        .then(({ data }) => {
          const { result, totalItems, totalPages, currentPage } = data.data;
          this.histories = result;
          this.totalItems = totalItems;
          this.totalPages = totalPages;
          this.currentPage = currentPage;
        })
        .catch((err) => {
          this.histories = [];
          this.loadError = true;
          const message = err.response
            ? err.response.data.message
            : 'Lỗi kết nối, vui lòng thử lại';
          makeToastFaile(message || 'Không tải được lịch sử thay đổi');
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.main ::v-deep {
  width: 100%;
  .table th,
  .table td {
    padding: 0.75rem;
    vertical-align: middle;
  }
  .change-item + .change-item {
    margin-top: 4px;
  }
  .old-value {
    color: #b5b5c3;
    text-decoration: line-through;
  }
}
</style>
